import { css } from "styled-components";

export default css`
    .link {
        font-weight: 300;
        color: ${p => p.theme.c.active};
        cursor: pointer;
        display: inline-block;

        border: none;
        background: transparent;
        outline: none;

        &:hover {
            text-shadow: 0 0 0.5px ${p => p.theme.c.active};
            text-decoration: underline;
        }

        &:visited {
            color: ${p => p.theme.c.boost};
        }

        &.link--light {
            color: ${p => p.theme.c.snowOnActive};

            &:hover {
                color: ${p => p.theme.c.whiteOnActive};
            }

            &:visited {
                color: ${p => p.theme.c.snowOnActive};
            }
        }

        &.link--disabled {
            pointer-events: none;
            color: ${p => p.theme.c.disabled};
        }
    }
`;
